import videojs from 'video.js';
import { v4 as uuidv4 } from 'uuid';
require('./mqtt.min.js');
const Component = videojs.getComponent('Component');

const DEFAULTS = {
  ws_url: '',
  access_id: '',
  event_id: '',
  messages: {
    show_id: {
      text: 'ID',
      value: (component) => {
        console.log('!!! comp', component, component.options, component.options_);
        return component.options.access_id;
      }
      //onrecive: null 
    },
    show_data: {
      text: '',
      value: (_, onrecive_data) => onrecive_data
    }
  },
  //reconnectAttempts: 10, // TODO
  reconnectTimeout: 2000,
  use_mqtt: false,
  mqtt: {
    url: '',
    topics: [],
    topic_callbacks: {
      show_id: function(payload) {
        this.showPopup({
          text: 'ID',
          value: this.access_id,
          position: payload.position
        });
      }
    },
    options: {
      username: 'broker_user'
    }
  }
};

/**
 * The button component for processing WebSocket messages 
 *
 * @param {Object} player   Main Player
 * @param {Object=} options Object of option names and values
 * @extends Button
 */
class WSMessagesManager extends Component {
  constructor(player, popup, options) {
    let options_ = videojs.mergeOptions({}, DEFAULTS);
    options_ = videojs.mergeOptions(options_, options);
    super(player, options_);
    this.url = options_.ws_url;
    this.player = player;
    this.popup = popup;
    this.messages = options_.messages;
    this.reconnectTimeout = options_.reconnectTimeout;
    this.event_id = options_.event_id;
    this.access_id = options_.access_id;
    this.options = options_;
    this.on('connected', () => {
      this.connected = true;
      this.connecting = false;
    });
    this.init();
  }

  dispose() {
    this.player.clearInterval(this.reconnectIntervalId);
    if (this.options.use_mqtt) {
      if (!this.mqtt_connection || !this.mqtt_connection.isConnected()) return;
      this.mqtt_connection.disconnect();
      return;
    }
    if (!this.socket) return;
    this.socket.close();
  }

  init() {
    if (this.options.use_mqtt) {
      return this.mqtt_connect();
    }

    this.connect(() => {
      if (!this.socket) return;
      try {
        //this.socket.onopen = () => console.info('WSMessages open connection');
        this.socket.onclose = event => {
          if (event.wasClean) {
            console.log('WSMessages closed normaly');
          } else {
            this.reconnect();
            console.log('WSMessages closed unexpectedly', event.code, event.reason);
          }
        };
        this.socket.onmessage = (msg) => this.processMsg(msg.data);
        this.socket.onerror = e => console.error("WSMessages  err: " + e);
      } catch (e) {
        console.error('WSMessages init err: ' + e);
      }
    });
  }

  connect(onConnect) {
    let cb = (url) => {
      if (!url) return;
      try {
        this.socket = new WebSocket(url);
        onConnect && onConnect();
        this.trigger('connected');
      } catch (e) {
        console.error('WSMessages create ws err: ' + e);
      }
    }; 
    typeof this.url === 'function' ? this.url(cb) : cb(this.url);
  }

  mqtt_connect() {
    if (!this.options.mqtt.topics) {
      console.warn('MQTTMessages: no topics for subscribe. Connection will not be established');
      return;
    }

    if (!this.options.mqtt.key) {
      console.warn('MQTTMessages: no settings for connect');
      return;
    }
    this.options.mqtt.options.password = window.atob(this.options.mqtt.key);

    this.connecting = true;
    this.mqtt_connection = new Paho.MQTT.Client(this.options.mqtt.host,
                                                this.options.mqtt.port,
                                                this.options.mqtt.path,
                                                uuidv4());

    // Обработка поступившего сообщения
    this.mqtt_connection.onMessageArrived = (message) => {
      let topic_levels = message.destinationName.split('/');
      let last_level = topic_levels[topic_levels.length - 1];
      let topic_callback = this.options.mqtt.topic_callbacks[last_level];
      topic_callback && topic_callback.bind(this)(JSON.parse(message.payloadString));
    };

    this.mqtt_connection.onConnectionLost = (error) => {
      if (!error.errorCode) return;

      console.log('MQTTMessages: lose connection: ', error);
      this.connected = false;
      this.connecting = false;
      this.reconnect();
    }

    let onSuccess = () => {
      console.log('MQTTMessages: successfully connected');
      this.options.mqtt.topics.forEach(topic => this.mqtt_connection.subscribe(topic));
      this.trigger('connected');
    }

    let onFailure = (error) => {
      console.log('MQTTMessages: an error occured: ', error);
      this.connected = false;
      this.connecting = false;
    }

    let conn_opts = {
      useSSL: true,
      userName: this.options.mqtt.options.username,
      password: this.options.mqtt.options.password,
      onSuccess: onSuccess,
      onFailure: onFailure,
      mqttVersion: 4
    }

    this.mqtt_connection.connect(conn_opts);
  }

  reconnect() {
    if (this.reconnectIntervalId) {
      return;
    }

    this.reconnectIntervalId = this.player.setInterval(() => {
      if (this.connecting) {
        console.log('WSMessages: reconnect in process...');
        return;
      }
      console.log('WSMessages: try reconnect...');
      this.init();
    }, this.reconnectTimeout);

    this.one('connected', () => {
      console.log('WSMessages: reconnected successfully');
      this.player.clearInterval(this.reconnectIntervalId);
      this.reconnectIntervalId = null;
    });
  }

  sendMsg(data) {
    this.socket.send(JSON.stringify(data));
  }

  processMsg(data) {
    let d = JSON.parse(data) || {};

    let onrecive_data;
    if (this.options.onrecive) {
      onrecive_data = this.options.onrecive(d);
      if (onrecive_data === false) return;
    }

    if (d.event_id && this.event_id * 1 != d.event_id * 1) return;
    let params = this.messages[d.type];

    if (!params) return;
    params.onrecive_data = onrecive_data;
    this.showPopup(params);
  }

  showPopup(params = {}) {
    if (!this.popup || !params) return;
    let {text, value, ...options} = params;
    text = this.player.localize(text);
    value = typeof value === 'function' ? value(this, params.onrecive_data) : value;
    if (!value) {
      return;
    }
    this.popup.show(text, value, options);
  }
}

Component.registerComponent('WSMessagesManager', WSMessagesManager);
export default WSMessagesManager;
